/* eslint-disable import/prefer-default-export */
export const LOGIN = '/login';
export const FORGOT = '/forgot';
export const CONFIRM = '/confirm';
export const ACTIVATED = '/activated';
export const LOGOUT = '/logout';

export const PATIENT_LIST = '/patients';
export const PATIENT_ADD = '/patients/add';
export const PATIENT_ID = '/patients/:id';

export const CAREPATH_LIST = '/carepaths';
export const CAREPATH_ADD = '/carepaths/add';
export const CAREPATH_ID = '/carepaths/:id';

export const ARTICLE_LIST = '/articles';
export const ARTICLE_ITEM = '/articles/:id';

export const MANAGEMENT = '/management';
export const MANAGEMENT_USER = '/management/user';
export const MANAGERUSER_ADD = '/management/user/add';
export const MANAGERUSER_ID = '/management/user/:id';

export const MANAGEMENT_ORG = '/management/organisation';
export const MANAGEMENT_ORG_ADD = '/management/organisation/add';
export const MANAGEMENT_ORG_ID = '/management/organisation/:id';

export const MANAGEMENT_CAREGIVER = '/management/caregiver';
export const MANAGEMENT_CAREGIVER_ADD = '/management/caregiver/add';
export const MANAGEMENT_CAREGIVER_ID = '/management/caregiver/:id';

export const MANAGEMENT_CAREINSTITUTION = '/management/careinstitution';
export const MANAGEMENT_CAREINSTITUTION_ADD = '/management/careinstitution/add';
export const MANAGEMENT_CAREINSTITUTION_ID = '/management/careinstitution/:id';

export const ABOUT = '/about';

export const MESSAGE_CENTER = '/messagecenter';
export const MESSAGE_CENTER_ITEM = '/messagecenter/:id';

export const URL = (url, param) => {
  const path = url.substring(0, url.indexOf(':'));
  return `${path}${param}`;
};
